import { render } from "./Debug.vue?vue&type=template&id=f08afa08&ts=true"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"

import "./Debug.vue?vue&type=style&index=0&id=f08afa08&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__